<lib-cdw-dialog
  [toolbarTitle]="'Move ' + devicesWithValidOu + (devicesWithValidOu === 1 ? ' Device' : ' Devices') + ' to Last User\'s OU'"
  [primaryButtonText]="currentStep === 'preview' ? 'Next' : 'Execute move'"
  [secondaryButtonText]="currentStep === 'preview' ? 'Cancel' : 'Previous step'"
  [dialogSize]="'largeSize'"
  [primaryButtonDisabled]="isLoading || devicesWithValidOu === 0"
  (primaryButtonClick)="currentStep === 'preview' ? onNext() : onConfirm()"
  (secondaryButtonClick)="currentStep === 'preview' ? onCancel() : onPrevious()"
  (dismissButtonClick)="onCancel()"
>
  <div class="dialog-body">
    <!-- STEP 1: Preview -->
    <ng-container *ngIf="currentStep === 'preview'">
      <!-- Summary -->
      <div class="summary-section">
        <div class="summary-text">
          Move the selected devices to the OU of their last user
        </div>
        <div class="devices-count">
          Of the <strong>{{ totalDeviceCount }}</strong> selected device{{ totalDeviceCount === 1 ? '' : 's' }},
          the following will be moved to the OUs:
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-container">
        <lib-cdw-spinner [type]="'apple'" [size]="'large'"></lib-cdw-spinner>
        <div class="loading-text">Loading OU destinations...</div>
      </div>

      <!-- Error State -->
      <div *ngIf="hasError && !isLoading" class="error-container">
        <div class="error-text">Unable to determine OU destinations for selected devices.</div>
      </div>

      <!-- Content (shown when not loading and no error) -->
      <ng-container *ngIf="!isLoading && !hasError">
        <!-- Warning for devices already in target OU -->
        <div *ngIf="devicesAlreadyInTargetOu > 0" class="info-section">
          <div class="info-text">
            <strong>{{ devicesAlreadyInTargetOu }}</strong> device{{ devicesAlreadyInTargetOu === 1 ? '' : 's' }}
            {{ devicesAlreadyInTargetOu === 1 ? 'is' : 'are' }} already in the target OU and will be skipped.
          </div>
        </div>

        <!-- Warning for devices without OU -->
        <div *ngIf="devicesWithoutOu > 0" class="warning-section">
          <div class="warning-text">
            <strong>{{ devicesWithoutOu }}</strong> device{{ devicesWithoutOu === 1 ? '' : 's' }}
            {{ devicesWithoutOu === 1 ? 'has' : 'have' }} no OU assigned and will not be moved.
            Only <strong>{{ devicesWithValidOu }}</strong> device{{ devicesWithValidOu === 1 ? '' : 's' }} will be moved.
          </div>
        </div>

        <!-- Search Field -->
        <div class="search-section">
          <lib-common-ui-components-text-input
            [placeholder]="'Search OUs...'"
            [iconPrefix]="'search'"
            [size]="'100%'"
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange($event)"
          ></lib-common-ui-components-text-input>
        </div>

        <!-- OU List -->
        <div class="ou-list-container">
          <div class="ou-list">
            <div
              *ngFor="let ouGroup of filteredOuGroups"
              class="ou-item"
              [class.unknown-ou]="ouGroup.ouPath === 'Unknown (No OU assigned)'"
            >
              <div class="ou-path">{{ ouGroup.ouPath }}</div>
              <div class="device-count">
                {{ ouGroup.deviceCount }} device{{ ouGroup.deviceCount === 1 ? '' : 's' }}
              </div>
            </div>

            <div *ngIf="filteredOuGroups.length === 0" class="no-results">
              No OUs match your search
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- STEP 2: Confirmation -->
    <ng-container *ngIf="currentStep === 'confirm'">
      <div class="confirmation-content">
        <div class="confirmation-section">
          <div class="confirmation-text">
            <strong>{{ devicesWithValidOu }}</strong> device{{ devicesWithValidOu === 1 ? '' : 's' }} will be moved to the OU of their last user as shown in the Previous step.
          </div>
        </div>

        <div class="warning-box">
          <div class="warning-box-header">
            <lib-cdw-icon class="warning-icon" icon="warning"></lib-cdw-icon>
            <span class="warning-box-title">WARNING! This action cannot be undone please confirm that you wish to continue.</span>
          </div>
        </div>

      </div>
    </ng-container>
  </div>
</lib-cdw-dialog>
